export default "<template>\n    <div id=\"input-container\" class=\"input-container\">\n        <slot></slot>\n    </div>\n</template>\n";